import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from '@nuxtjs/composition-api';

interface Props {
  items: Array<{ name: string; link?: string }>;
  includeHomeIcon?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 't-breadcrumbs',
  props: {
    items: null,
    includeHomeIcon: { type: Boolean }
  },
  setup(__props: any) {



const route = useRoute();

const shouldShowAsLink = (item: { name: string; link?: string }) => {
  return item.link && item.link !== route.value.path;
};

return { __sfc: true,route, shouldShowAsLink }
}

})